/************************************************************************
* Overrides default settings for datatables                             *
*************************************************************************/
(function ($) {
    if (!$.fn.dataTable) {
        return;
    }

    $.fn.dataTable.ext.pager.numbers_length = app.consts.grid.pagerSize;

    // Keyboard Shortcuts
    const commonShortcutCallback = function (type, e, $tooltipTarget) {
        if (app.isOverlayShown() && $tooltipTarget.closest(".modal.show").length == 0) {
            return;
        }

        if (!app.isOverlayShown() || $(".modal.show").last().get(0) == $tooltipTarget.closest(".modal.show").get(0)) {
            e.stopPropagation();
            e.preventDefault();

            let $tooltipTargets = $tooltipTarget;
            const $lastModal = $(".modal.show").last();
            if ($lastModal.length > 0) {
                if ($lastModal.get(0) == $tooltipTarget.closest(".modal.show").get(0)) {
                    $tooltipTargets = $lastModal.find($tooltipTarget);
                }
            }

            const visibleTables = $.fn.dataTable.tables({ api: false, visible: true });
            _.each(visibleTables, visibleTable => {
                const dataTable = $(visibleTable).DataTable();
                const visibleTableContainer = dataTable.table().container();
                const $visibleTableContainer = $(visibleTableContainer);
                const $visibleTableContainerLastModalTooltipTargets = $visibleTableContainer.find($tooltipTargets);
                if ($visibleTableContainerLastModalTooltipTargets.length > 0) {
                    const $pageItem = $visibleTableContainerLastModalTooltipTargets.closest("li.paginate_button.page-item");
                    if ($pageItem.length > 0) {
                        if ($pageItem.hasClass("disabled")) {
                            return;
                        }
                    }

                    let container;
                    if ($visibleTableContainer.closest(".modal-dialog-scrollable").length > 0) {
                        container = $visibleTableContainer.closest(".modal-body").get(0);
                    } else if ($visibleTableContainer.closest(".modal").length > 0) {
                        container = $visibleTableContainer.closest(".modal").get(0);
                    }

                    const action = function (t, $el) {
                        switch (t) {
                            case "focus":
                                $el.focus();
                                break;

                            case "click":
                                $el.click();
                                break;
                        }
                    }

                    if ($visibleTableContainerLastModalTooltipTargets.first().isInView(container)) {
                        const $element = $visibleTableContainerLastModalTooltipTargets.first();

                        action(type, $element);

                        return false;
                    } else if ($visibleTableContainerLastModalTooltipTargets.last().isInView(container)) {
                        const $element = $visibleTableContainerLastModalTooltipTargets.last();

                        action(type, $element);

                        return false;
                    } else if ($visibleTableContainerLastModalTooltipTargets.length >= 3) {
                        const $element = $($visibleTableContainerLastModalTooltipTargets[1]);

                        action(type, $element);

                        return false;
                    } else {
                        const $element = $visibleTableContainerLastModalTooltipTargets.first();

                        action(type, $element);

                        return false;
                    }
                }
            });
        }
    };

    const commonShortcutFocusCallback = function (e, $tooltipTarget) {
        commonShortcutCallback("focus", e, $tooltipTarget);
    };

    const commonShortcutClickCallback = function (e, $tooltipTarget) {
        commonShortcutCallback("click", e, $tooltipTarget);
    };

    const keyboardShortcutManager = new KeyboardShortcutManager(document,
        [
            // focus on page size input
            new KeyboardShortcutItem([app.consts.keyboardKey.alt, "-"], "select.page-size-input", commonShortcutFocusCallback, ".dataTables_wrapper"),
            // refresh
            new KeyboardShortcutItem([app.consts.keyboardKey.alt, "W"], "button.dt-refresh", commonShortcutClickCallback, ".dataTables_wrapper"),
            // go to previous page
            new KeyboardShortcutItem([app.consts.keyboardKey.alt, app.consts.keyboardKey.pageUp], "ul.pagination li.page-item.previous a.page-link", commonShortcutClickCallback, ".dataTables_wrapper"),
            // go to next page
            new KeyboardShortcutItem([app.consts.keyboardKey.alt, app.consts.keyboardKey.pageDown], "ul.pagination li.page-item.next a.page-link", commonShortcutClickCallback, ".dataTables_wrapper"),
            // go to first page
            new KeyboardShortcutItem([app.consts.keyboardKey.alt, app.consts.keyboardKey.home], 'ul.pagination li.page-item.first a.page-link, ul.pagination li.page-item.first-item a.page-link', commonShortcutClickCallback, ".dataTables_wrapper"),
            // go to last page
            new KeyboardShortcutItem([app.consts.keyboardKey.alt, app.consts.keyboardKey.end], 'ul.pagination li.page-item.last a.page-link, ul.pagination li.page-item.last-item a.page-link', commonShortcutClickCallback, ".dataTables_wrapper")
        ]);

    var fixedFooterAdjust = function () {
        const fixedHeader = this;
        setTimeout(function () {
            $(fixedHeader.s.dt.table().node()).closest(".dataTables_scrollBody").floatingScroll("update");
        }, 100);

        if (fixedHeader.c.footer && fixedHeader.dom.tfoot.length > 0) {
            const $tableWrapper = $(fixedHeader.s.dt.table().container());
            const $floatingScroll = $(".fl-scrolls", $tableWrapper);

            // if this.dom.tfoot.length > 0, it means that the table has a tfoot html tag.
            // if it has, floating scroll is set to be positioned above the floating footer so that it's not
            // obstructed by it.
            if (fixedHeader.dom.footer.floating && fixedHeader.dom.footer.floating.is(":visible")) {
                $floatingScroll.removeClass("fl-scrolls-hidden");

                const $modal = $tableWrapper.closest(".modal");
                if ($modal.length > 0 && $tableWrapper.closest(".modal-dialog-scrollable").length > 0) {
                    const $scrollablePane = $tableWrapper.closest(".modal-body");

                    const scrollablePaneOffsetBottom = $scrollablePane.offset().top + $scrollablePane.outerHeight();
                    const scrollablePaneOffsetFromBottom = $modal.outerHeight() - scrollablePaneOffsetBottom;
                    $floatingScroll.css("bottom", scrollablePaneOffsetFromBottom + fixedHeader.dom.footer.floating.height());
                } else {
                    $floatingScroll.css("bottom", fixedHeader.dom.footer.floating.height());
                }
            } else {
                // if the table is inside a modal, the floating scroll might not be hidden even after scrolling past the tfoot,
                // therefore manually hide it.
                $floatingScroll.addClass("fl-scrolls-hidden");
            }
        }
    };

    /* Set the defaults for DataTables initialisation */
    $.extend(true, $.fn.dataTable.defaults, {
        dom: '<"top clearfix"<"left"il><"right"BpG>><"middle"rMt><"bottom clearfix"<"left"il><"right"BpG>><"clearfix">',
        //"dom": "<'row'<'col-md-6 col-sm-6'l><'col-md-6 col-sm-6'f>r><'table-scrollable't><'row'<'col-md-5 col-sm-5'i><'col-md-7 col-sm-7'p>>", // default layout with horizontal scrollable datatable
        //"dom": "<'row'<'col-md-6 col-sm-12'l><'col-md-6 col-sm-12'f>r>t<'row'<'col-md-5 col-sm-12'i><'col-md-7 col-sm-12'p>>", // datatable layout without  horizontal scroll(used when bootstrap dropdowns used in the datatable cells)
        //language: {
        //    emptyTable: "No data available in table",
        //    info: "Showing <span class=\"dataTables-highlight\">_START_</span> to <span class=\"dataTables-highlight\">_END_</span> of <span class=\"dataTables-highlight\">_TOTAL_</span> records",
        //    infoEmpty: "Showing <span class=\"dataTables-highlight\">0</span> to <span class=\"dataTables-highlight\">0</span> of <span class=\"dataTables-highlight\">0</span> records",
        //    infoFiltered: "(filtered from <span class=\"dataTables-highlight\">_MAX_</span> total records)",
        //    infoPostFix: "",
        //    infoThousands: ",",
        //    lengthMenu: "Show <span class=\"dataTables-highlight\">_MENU_</span> records",
        //    loadingRecords: "Loading...",
        //    processing: "Loading...",
        //    search: "Search:",
        //    zeroRecords: "No matching records found",
        //    paginate: {
        //        first: "First",
        //        last: "Last",
        //        next: "Next",
        //        previous: "Previous"
        //    },
        //    aria: {
        //        sortAscending: ": activate to sort column ascending",
        //        sortDescending: ": activate to sort column descending"
        //    }
        //},
        classes: {
            sPageLink: "page-link"
        },
        rowId: "id",
        lengthMenu: app.consts.grid.defaultPageSizes,
        pageLength: app.dataTables.getPageSize(),
        scrollX: true,
        fixedHeader: {
            header: true,
            footer: true,
            headerOffset: app.utils.theme.getFixedHeaderOffset,
            footerOffset: app.utils.theme.getFixedFooterOffset,
            container: ".dataTables_scroll",
            //onScroll: fixedFooterAdjust,
            onUpdate: fixedFooterAdjust
        },
        select: true,
        searching: false,
        buttons: {
            dom: {
                button: {
                    className: ""
                }
            },
            buttons: [
                {
                    className: "dt-retrieved-datetime",
                    init: function (api, node, config) {
                        const initSettings = api.settings().init();

                        if (!initSettings.serverSide || (!initSettings.ajax && !initSettings.listAction)) {
                            setTimeout(function () {
                                $(node).remove();
                            }, 50);

                            return;
                        }

                        setTimeout(function () {
                            const $container = $(node).parent();
                            $container
                                .removeClass("btn-group")
                                .removeClass("flex-wrap")
                                .addClass("d-flex")
                                .addClass("align-items-center");

                            const $button = $(".dt-retrieved-datetime", $container);

                            const $span = $('<span class="dt-retrieved-datetime mr-5 retrieved-on"></span>');

                            $span.insertAfter($button);
                            $button.remove();
                        }, 50);
                    }
                },
                {
                    className: "dt-auto-refresh",
                    init: function (api, node, config) {
                        const initSettings = api.settings().init();

                        if (!initSettings.ajax && !initSettings.listAction) {
                            setTimeout(function () {
                                $(node).remove();
                            }, 50);

                            return;
                        }

                        function polling(dataTableApi, duration) {
                            const $wrapper = $(dataTableApi.table().container());

                            const timeoutId = setTimeout(function () {
                                $wrapper.data("ajax-disable-busy", true);

                                dataTableApi.ajax.reload(function () {
                                    polling(dataTableApi, duration);
                                }, false);
                            }, duration);
                                                        
                            if ($wrapper.data("auto-refresh")) {
                                $wrapper.data("auto-refresh", timeoutId);
                            } else {
                                clearTimeout(timeoutId);
                            }
                        }

                        setTimeout(function () {
                            const $container = $(node).parent();

                            const $button = $(".dt-auto-refresh", $container);

                            const $switch = $(`<span class="switch switch-sm switch-icon mr-3" data-color-set="info" data-toggle="tooltip" title="${app.localize("AutoRefresh")}">
                                                <label>
                                                    <input class="dt-auto-refresh" type="checkbox" />
                                                    <span></span>
                                                </label>
                                            </span>`);

                            $('input[type="checkbox"]', $switch).change(function () {
                                const $wrapper = $(api.table().container());

                                const $checkbox = $('input[type="checkbox"].dt-auto-refresh', $wrapper);
                                $checkbox.prop("checked", $(this).is(":checked"));

                                const $sw = $checkbox.closest(".switch");
                                if ($checkbox.is(":checked")) {
                                    $sw.addClass("switch-info");

                                    $wrapper.data("auto-refresh", true);

                                    polling(api, 5000);
                                    api.ajax.reload(null, false);
                                } else {
                                    $sw.removeClass("switch-info");

                                    const timeoutId = $wrapper.data("auto-refresh");
                                    if (timeoutId) {
                                        clearTimeout(timeoutId);
                                        $wrapper.data("auto-refresh", false);
                                    }
                                }
                            });

                            $switch.insertAfter($button);
                            $button.remove();
                        }, 50);
                    }
                },
                {
                    text: '<i class="fas fa-redo-alt"></i>',
                    attr: {
                        "data-toggle": "tooltip",
                        title: app.localize("Refresh")
                    },
                    className: "btn btn-xs btn-icon btn-light-info dt-refresh",
                    init: function (api, node, config) {
                        const initSettings = api.settings().init();

                        if (!initSettings.ajax && !initSettings.listAction) {
                            setTimeout(function () {
                                $(node).remove();
                            }, 50);

                            return;
                        }
                    },
                    action: function (e, dt, node, config) {
                        abp.event.trigger("app.refresh.dt", e, dt, node, config);

                        dt.ajax.reload(null, false);
                    }
                },
                {
                    text: '<i class="fad fa-filter-list text-warning"></i><span class="pulse-ring"></span>',
                    attr: {
                        "data-toggle": "tooltip",
                        title: app.localize("FilterOn"),
                        hidden: "hidden"
                    },
                    className: "btn btn-icon btn-clean pulse pulse-warning dt-filter",
                    action: function (e, dt, node, config) {
                        abp.event.trigger("app.filterActiveClicked.dt", e, dt, node, config);
                    },
                    init: function (api, node, config) {
                        const $node = $(node);
                        const $nodeSpan = $node.children();

                        $node.append($nodeSpan.children());
                        $nodeSpan.remove();

                        const eventHandler = function (operator) {
                            const callbackType = typeof (operator);

                            switch (callbackType) {
                                case "function":
                                    if (operator.call(api, api, node, config)) {
                                        $node.show();
                                    } else {
                                        $node.hide();
                                    }
                                    break;

                                case "boolean":
                                    if (operator) {
                                        $node.show();
                                    } else {
                                        $node.hide();
                                    }
                                    break;
                            }
                        };
                        abp.event.on("app.showFilterActiveButtonEvent.dt", eventHandler);

                        $(api.table().node()).on("destroy.dt", function (e, settings) {
                            abp.event.off("app.showFilterActiveButtonEvent.dt", eventHandler);
                        });
                    }
                }
            ]
        },
        order: [],
        initComplete: function (settings, json) {
            const api = new $.fn.dataTable.Api(settings);
            const $wrapper = $(api.table().container());

            $(".dataTables_empty span", $wrapper).text(settings.oLanguage.sEmptyTable);

            const $scrollContainer = $(api.table().node()).closest(".dataTables_scrollBody");
            //var $flScrollsViewport = $('<div class="fl-scrolls-viewport"></div>');
            //var $flScrollsBody = $('<div class="fl-scrolls-body"></div>').appendTo($flScrollsViewport);

            //$scrollContainer.after($flScrollsViewport);
            //$flScrollsBody.append($scrollContainer);

            setTimeout(function () {
                $scrollContainer.addClass("fl-scrolls-hoverable");
                $scrollContainer.floatingScroll();
                $scrollContainer.on("scroll", app.throttle(30, function () {
                    const hoveredRow = $wrapper.data("hovered-row");
                    if (hoveredRow) {
                        const $hoveredRow = $(hoveredRow);
                        const containerScrollLeft = $scrollContainer.scrollLeft();
                        if (containerScrollLeft > 20) {
                            $hoveredRow.removeClass("unhover").addClass("hover");
                            $("td.actions div.datatable-action-buttons-container", $hoveredRow)
                                .css("left", `calc(var(--cell-padding-left) + ${containerScrollLeft}px)`);
                        } else {
                            $("td.actions div.datatable-action-buttons-container", $hoveredRow)
                                .one("transitionend", function (e) {
                                    $(this).closest("tr").removeClass("unhover");
                                })
                                .css("left", "");

                            $hoveredRow.removeClass("hover").addClass("unhover");
                        }
                    }
                }));
            });

            keyboardShortcutManager.injectTooltips($wrapper);
        }
    });

    const $dataTablesLocalization = $("#DataTablesLocalization");
    if ($dataTablesLocalization.length > 0) {
        $.fn.dataTable.defaults.language = JSON.parse($dataTablesLocalization.text());
    } else {
        $.fn.dataTable.defaults.language = {};
    }
    $.fn.dataTable.defaults.language.decimal = abp.numberFormatter.getDecimalSeparator();
    $.fn.dataTable.defaults.language.thousands = abp.numberFormatter.getGroupSeparator();

    /* Default class modification */
    $.extend($.fn.dataTableExt.oStdClasses, {
        "sWrapper": "dataTables_wrapper",
        "sFilterInput": "form-control form-control-sm",
        "sLengthSelect": "form-control form-control-sm page-size-input"
    });

    $.fn.dataTable.ext.classes.sPageButton = "paginate_button";

    // In 1.10 we use the pagination renderers to draw the Bootstrap paging,
    // rather than  custom plug-in
    $.fn.dataTable.defaults.renderer = "bootstrap";
    $.fn.dataTable.ext.renderer.pageButton.bootstrap = function (settings, host, idx, buttons, page, pages) {
        var api = new $.fn.dataTable.Api(settings);
        var classes = settings.oClasses;
        var lang = settings.oLanguage.oPaginate;
        var btnDisplay, btnClass, linkAttributes;

        var index = 0;
        var attach = function (container, buttons) {
            var i, ien, node, button;
            var clickHandler = function (e) {
                e.preventDefault();
                if (e.data.action !== "ellipsis" && !$(e.target).hasClass("disabled")) {
                    api.page(e.data.action).draw(false);

                    const $wrapper = $(e.target).closest(".dataTables_wrapper");
                    let currentPage = page;
                    switch (e.data.action) {
                        case "first":
                            currentPage = 0;
                            break;

                        case "previous":
                            currentPage = currentPage - 1;
                            break;

                        case "next":
                            currentPage = currentPage + 1;
                            break;

                        case "last":
                            currentPage = currentPage - 1;
                            break;

                        default:
                            currentPage = e.data.action;
                            break;
                    }
                    $(".pagination-input-container .pagination-input", $wrapper).val(currentPage + 1);
                }
            };

            for (i = 0, ien = buttons.length; i < ien; i++) {
                button = buttons[i];

                if (_.isArray(button)) {
                    attach(container, button);
                } else {
                    btnDisplay = "";
                    btnClass = "";
                    linkAttributes = {};

                    switch (button) {
                        case "ellipsis":
                            btnDisplay = "&hellip;";
                            btnClass = " disabled";
                            break;

                        case "first":
                            //btnDisplay = lang.sFirst;
                            btnDisplay = `<i class="fas fa-angles-left"></i>`;
                            btnClass = ` ${button}${page > 0 ? "" : " disabled"}`;
                            if (page > 0) {
                                linkAttributes = {
                                    "data-toggle": "tooltip",
                                    "title": app.localize("Pagination.FirstPage")
                                }
                            }
                            break;

                        case "previous":
                            //btnDisplay = lang.sPrevious;
                            btnDisplay = `<i class="fas fa-angle-left"></i>`;
                            btnClass = ` ${button}${page > 0 ? "" : " disabled"}`;
                            if (page > 0) {
                                linkAttributes = {
                                    "data-toggle": "tooltip",
                                    "title": app.localize("Pagination.PreviousPage")
                                }
                            }
                            break;

                        case "next":
                            //btnDisplay = lang.sNext;
                            btnDisplay = `<i class="fas fa-angle-right"></i>`;
                            btnClass = ` ${button}${page < pages - 1 ? "" : " disabled"}`;
                            if (page < pages - 1) {
                                linkAttributes = {
                                    "data-toggle": "tooltip",
                                    "title": app.localize("Pagination.NextPage")
                                }
                            }
                            break;

                        case "last":
                            //btnDisplay = lang.sLast;
                            btnDisplay = `<i class="fas fa-angles-right"></i>`;
                            btnClass = ` ${button}${page < pages - 1 ? "" : " disabled"}`;
                            if (page < pages - 1) {
                                linkAttributes = {
                                    "data-toggle": "tooltip",
                                    "title": app.localize("Pagination.LastPage")
                                }
                            }
                            break;

                        default:
                            btnDisplay = button + 1;
                            btnDisplay = $.fn.dataTable.render
                                .number(settings.oLanguage.sThousands, settings.oLanguage.sDecimal, 0)
                                .display(btnDisplay);
                            btnClass = `${page === button ? " active" : ""}${button === 0 ? " first-item" : (i === ien - 1 ? " last-item" : "")}`;
                            if (button === 0) {
                                linkAttributes = {
                                    "data-toggle": "tooltip",
                                    "title": app.localize("Pagination.FirstPage")
                                }
                            } else if (i === ien - 1) {
                                linkAttributes = {
                                    "data-toggle": "tooltip",
                                    "title": app.localize("Pagination.LastPage")
                                }
                            }
                            break;
                    }

                    if (btnDisplay) {
                        var $a = $("<a>", $.extend({
                            'href': "#",
                            'class': classes.sPageLink,
                            'data-dt-idx': index++,
                            'data-dt-page': page
                        }, linkAttributes))
                            .html(btnDisplay);

                        node = $("<li>", {
                            'class': classes.sPageButton + " page-item" + btnClass,
                            'aria-controls': settings.sTableId,
                            'id': idx === 0 && typeof button === "string" ?
                                settings.sTableId + "_" + button : null
                        })
                            .append($a)
                            .appendTo(container);

                        if (!node.hasClass("disabled")) {
                            $a.attr("tabindex", settings.iTabIndex);
                        } else {
                            $a.attr("tabindex", -1);
                            $a.attr("aria-disabled", "true");
                        }

                        settings.oApi._fnBindAction(
                            node, {
                            action: button
                        }, clickHandler
                        );
                    }
                }
            }
        };

        attach(
            $(host).empty().html('<ul class="pagination"/>').children("ul"),
            buttons
        );
    };

    $.fn.dataTable.customDefaults = $.fn.dataTable.customDefaults || {};
    $.fn.dataTable.customDefaults.columns = $.fn.dataTable.customDefaults.columns || {};
    $.extend(true, $.fn.dataTable.customDefaults.columns, {
        index: {
            targets: "index",
            className: "index",
            searchable: false,
            orderable: false,
            render: function (data, type, row, meta) {
                return data ?? "";

                //const api = new $.fn.dataTable.Api(meta.settings);
                //return $.fn.dataTable.render
                //    .number(meta.settings.oLanguage.sThousands, meta.settings.oLanguage.sDecimal, 0)
                //    .display(api.page.info().start + meta.row + 1);
            }
        },
        entityStatus: {
            targets: "dt-entity-status",
            className: "status stack",
            data: "status",
            render: function (status) {
                const $span = $("<span />").addClass("label label-inline");

                switch (status) {
                    case app.enums.entityStatus.active:
                        $span.addClass("label-success").text(app.localize("EntityStatus.Active"));
                        break;

                    case app.enums.entityStatus.inactive:
                        $span.addClass("label-warning").text(app.localize("EntityStatus.Inactive"));
                        break;

                    case app.enums.entityStatus.deleted:
                        $span.addClass("label-danger").text(app.localize("EntityStatus.Deleted"));
                        break;
                }

                return $span[0].outerHTML;
            }
        },
        changeStatus: function (isVisible = true) {
            return {
                targets: "dt-change-status",
                className: "status",
                data: "changeStatus",
                render: function (status) {
                    const $span = $("<span />").addClass("label label-inline");

                    switch (status) {
                        case app.enums.changeStatus.created:
                            $span.addClass("label-success").text(app.localize("ChangeStatus.Created"));
                            break;

                        case app.enums.changeStatus.updated:
                            $span.addClass("label-warning").text(app.localize("ChangeStatus.Updated"));
                            break;

                        case app.enums.changeStatus.deleted:
                            $span.addClass("label-danger").text(app.localize("ChangeStatus.Deleted"));
                            break;

                        default:
                            status = app.enums.changeStatus.unchanged;
                            $span.addClass("label-default").text(app.localize("ChangeStatus.Unchanged"));
                            break;
                    }

                    return $span[0].outerHTML;
                },
                visible: isVisible
            };
        },
        createdOn: {
            targets: "dt-creation-time",
            className: "datetime",
            data: "creationTime",
            render: function (creationTime) {
                return creationTime
                    ? `${abp.dateTimeFormatter.formatShortDate(creationTime)} ${abp.dateTimeFormatter.formatLongTime(creationTime)}`
                    : app.localize("NotAvailable");
            }
        },
        lastModifiedOn: {
            targets: "dt-modification-time",
            className: "datetime",
            data: "lastModifiedOn",
            render: function (modificationTime) {
                return modificationTime
                    ? `${abp.dateTimeFormatter.formatShortDate(modificationTime)} ${abp.dateTimeFormatter.formatLongTime(modificationTime)}`
                    : app.localize("NotAvailable");
            }
        }
    });

    $(document).on("preInit.dt", function (e, settings) {
        const api = new $.fn.dataTable.Api(settings);

        const $tableWrapper = $(api.table().container());
        $(".dataTables_processing", $tableWrapper).remove(); // remove the "Loading..." div

        // when the setting "serverSide" is true, there is no text indicating that the datatable is loading as data is being retrieved from the server for the first time.
        // the codes below is to emulate the text indicator as the setting "serverSide" set to false.
        if ($(".dataTables_empty", $tableWrapper).length == 0) {
            $(".dataTables_scroll", $tableWrapper).append(`<div class="dataTables_empty"><span>${settings.oLanguage.sProcessing}</span></div>`);
        }
        const $tBody = $(".dataTables_scroll > .dataTables_scrollBody > table.dataTable > tbody", $tableWrapper);
        if ($("tr", $tBody).length == 0) {
            $tBody.append(`<tr class="odd"><td class="dataTables_empty" colspan="${api.columns(":visible").nodes().length}"></td></tr>`);
        }
    });

    // when a tab is shown, re-adjust the columns of datatables, because when a datatable is not visible,
    // its columns' width couldn't be calculated.
    $(document).on("shown.bs.tab", 'a[data-toggle="tab"]', function (e) {
        const associatedPaneId = $(e.target).attr("href");
        app.dataTables.resizeActionButtonsContainer(associatedPaneId);
    });

    // when a modal is shown, re-adjust the columns of datatables, because when a datatable is not visible,
    // its columns' width couldn't be calculated.
    $(document).on("shown.bs.modal", ".modal", function (e) {
        app.dataTables.resizeActionButtonsContainer(e.target);
    });

    $(document).on("shown.bs.collapse", 'div.collapse', function () {
        app.dataTables.resizeActionButtonsContainer(this);
    });

    $(document).on("preDraw.dt", function (e, settings) {
        const api = new $.fn.dataTable.Api(settings);

        keyboardShortcutManager.hideTooltips(api.table().container());
    });

    $(document).on("draw.dt", function (e, settings) {
        const api = new $.fn.dataTable.Api(settings);
        const $table = $(api.table().node());

        // #region Populate the "index" column with running number.
        // https://datatables.net/examples/api/counter_columns.html
        let i = 1;
        api
            .cells(".index", { search: "applied", order: "applied" })
            .every(function (rowIndex) {
                let displayedIndex = $.fn.dataTable.render
                    .number(settings.oLanguage.sThousands, settings.oLanguage.sDecimal, 0)
                    .display(api.page.info().start + i);

                const indexProvider = settings?.oInit?.indexProvider;

                if (indexProvider) {
                    const index = indexProvider.call(api.row(rowIndex), i, settings);

                    if (index != null) {
                        i = index;

                        displayedIndex = $.fn.dataTable.render
                            .number(settings.oLanguage.sThousands, settings.oLanguage.sDecimal, 0)
                            .display(api.page.info().start + i);

                        i++;
                    } else {
                        displayedIndex = "";
                    }

                    this.data(displayedIndex);
                    return;
                }

                this.data(displayedIndex);

                i++;
            });
        // #endregion

        const $wrapper = $(api.table().container());

        setTimeout(function () {
            const $emptyDiv = $("div.dataTables_empty", $wrapper);
            const $emptyCell = $("td.dataTables_empty", $table);
            if ($emptyCell.length > 0) {
                const $span = $("<span></span>");
                $span.append($emptyCell.html());

                $emptyCell.empty();

                if ($emptyDiv.length == 0) {
                    const $container = $emptyCell.closest("div.dataTables_scroll");
                    $('<div class="dataTables_empty"></div>')
                        .prependTo($container)
                        .append($span);
                } else {
                    $emptyDiv.show();
                }
            } else {
                $emptyDiv.hide();
            }

            $table.closest(".dataTables_scrollBody").floatingScroll("update");

            //$(".datatable-action-buttons-container-placeholder", $table).each(function () {
            //    // explicitly set a width and height to the action buttons placeholder, so that when its inner container turned "absolute" positioned,
            //    // it will not shrink/collapse and still retain its width and height.
            //    $(this).width($(".datatable-action-buttons-container", this).width());
            //    $(this).height($(".datatable-action-buttons-container", this).height());
            //});
        }, 100);

        keyboardShortcutManager.injectTooltips($wrapper);

        const tryMaxCount = 3;
        let tryCount = 0;
        const tryAdjustAgain = function () {
            setTimeout(function () {
                try {
                    api.columns.adjust();
                } catch (exception) {
                    if (tryCount++ < tryMaxCount) {
                        tryAdjustAgain();
                    } else {
                        throw exception;
                    }
                }
            }, 300);
        };

        try {
            api.columns.adjust();
        } catch (exception) {
            // if failed, retry with a delay.
            tryAdjustAgain();
        }
    });

    // when a datatable page size is changed.
    $(document).on("length.dt", function (e, settings, length) {
        app.dataTables.setPageSize(length);
        $.fn.dataTable.defaults.pageLength = length;
    });

    // when a page is about to change.
    $(document).on("page.dt", function (e, settings) {

    });

    $(document).on("destroy.dt", function (e, settings) {
        const api = new $.fn.dataTable.Api(settings);
        const $table = $(api.table().node());
        $table.closest(".dataTables_scrollBody").floatingScroll("destroy");
    });

    // float the actions buttons when hovering on the row only when it's being horizontally scrolled for more than 20px.
    $(document)
        .on("mouseenter", "table.dataTable tbody tr", function () {
            const $dataTable = $(this).closest(".dataTable");
            if (!$.fn.dataTable.isDataTable($dataTable)) {
                return;
            }

            const api = $dataTable.DataTable();
            const $wrapper = $(api.table().container());
            $wrapper.data("hovered-row", this);

            const containerScrollLeft = $(this).closest(".dataTables_scrollBody").scrollLeft();
            if (containerScrollLeft > 20) {
                $(this).removeClass("unhover").addClass("hover");
                $("td.actions div.datatable-action-buttons-container", this).css("left", `calc(var(--cell-padding-left) + ${containerScrollLeft}px)`);
            }
        })
        .on("mouseleave", "table.dataTable tbody tr", function () {
            const $dataTable = $(this).closest(".dataTable");
            if (!$.fn.dataTable.isDataTable($dataTable)) {
                return;
            }

            const api = $dataTable.DataTable();
            const $wrapper = $(api.table().container());
            $wrapper.removeData("hovered-row");

            if ($(this).hasClass("hover")) {
                $("td.actions div.datatable-action-buttons-container", this)
                    .one("transitionend", function (e) {
                        $(this).closest("tr").removeClass("unhover");
                    })
                    .css("left", "");

                $(this).removeClass("hover").addClass("unhover");
            }
        });


    app.events = app.events || {};
    app.events.entityStatusChanged = function (data) {
        const visibleTables = $.fn.dataTable.tables({ visible: true });

        if (_.isEmpty(visibleTables) === 0) {
            return;
        }

        if (visibleTables.length > 1) {
            alert("There are more than one visible DataTable on the page. You might want to override the app.entityStatusChanged event.");
            return;
        }

        const api = $(_.first(visibleTables)).DataTable();
        const cell = api.cell(`#${data.id}`, ".dt-entity-status");
        if (cell.length > 0) {
            cell.data(data.status);
        }

        const tableInstance = $(api.table().node()).dataTable();
        const row = api.row(`#${data.id}`);
        const rowNode = row.node();
        const rowData = row.data();
        $.fn.dataTable.defaults.rowCallback.call(tableInstance, rowNode, rowData);

        // toastr.js doesn't work well with our modified jQuery show/hide functions inside abp event bus.
        // so we introduce a delay so that the toast can be shown.
        setTimeout(function () {
            abp.notify.entityStatusChanged(data.status, data.entityName);
        }, 500);
    };
    abp.event.on("app.entityStatusChanged", app.events.entityStatusChanged);

    app.events.changeStatusChanged = function (data) {
        const visibleTables = $.fn.dataTable.tables({ visible: true });

        if (_.isEmpty(visibleTables) === 0) {
            return;
        }

        if (visibleTables.length > 1) {
            alert("There are more than one visible DataTable on the page. You might want to override the app.changeStatusChanged event.");
            return;
        }

        const api = $(_.first(visibleTables)).DataTable();
        const cell = api.cell(`#${data.id}`, ".dt-entity-status");
        if (cell.length > 0) {
            cell.data(data.status);
        }

        const tableInstance = $(api.table().node()).dataTable();
        const row = api.row(`#${data.id}`);
        const rowNode = row.node();
        const rowData = row.data();
        $.fn.dataTable.defaults.rowCallback.call(tableInstance, rowNode, rowData);
    };
    abp.event.on("app.changeStatusChanged", app.events.changeStatusChanged);

    $(function () {
        /*
        if (window.KTLayoutAsideToggle) {
            window.KTLayoutAsideToggle.getToggle()
                .on("afterOn", function () {
                    setTimeout(function () {
                        const api = $.fn.dataTable.tables({ api: true, visible: true });
                        api.columns.adjust();
                    }, 1000);
                })
                .on("afterOff", function () {
                    setTimeout(function () {
                        const api = $.fn.dataTable.tables({ api: true, visible: true });
                        api.columns.adjust();
                    }, 1000);
                });
        }
        
        let dataTableColumnsRedrawTimeout;
        const classWatcher = new ClassWatcher($("body").get(0), ["aside-minimize"], function (currentClasses, previousClasses) {
            if (dataTableColumnsRedrawTimeout) {
                clearTimeout(dataTableColumnsRedrawTimeout);
            }

            dataTableColumnsRedrawTimeout = setTimeout(function () {
                const api = $.fn.dataTable.tables({ api: true, visible: true });
                api.columns.adjust();
            }, 1000);
        });
        */
        $(".aside").on("transitionend", function (e) {
            if (this === e.target) {
                const api = $.fn.dataTable.tables({ api: true, visible: true });
                api.columns.adjust();
            }
        });
    });
})(jQuery);

(function ($) {
    // codes on using the keyboard navigation on datatables.

    $(document).on("draw.dt", function (e, settings) {
        // places cursor row on the first row after table refresh.

        const api = new $.fn.dataTable.Api(settings);
        const $wrapper = $(api.table().container());

        const index = 0;
        $wrapper.data("cursor-index", index);
        $wrapper.data("last-selected-index", index);
        $wrapper.data("last-selected-state", true);
        const $cursorRow = $(api.row(index).node());
        $cursorRow.addClass("cursor");

        api.table().node().focus({ preventScroll: true });
    });

    $(document).on("select.dt", function (e, dt, type, indexes) {
        if (dt) {
            if (type === "row") {
                //const $wrapper = $(dt.table().container());

                //const cursorRowIndex = $wrapper.data("cursor-index");
                //const $cursorRow = $(dt.row(cursorRowIndex).node());

                //$cursorRow.removeClass("cursor");

                //let index = _.last(indexes);
                //if (index === cursorRowIndex && indexes.length > 1) {
                //    index = _.first(indexes);
                //}

                //const latestSelectedRow = dt.row(index).node();
                //$(latestSelectedRow).addClass("cursor");

                //$wrapper.data("cursor-index", index);
            }
        }
    });

    $(document).on("deselect.dt", function (e, dt, type, indexes) {
        if (dt) {
            if (type === "row") {
                //const $wrapper = $(dt.table().container());

                //const cursorRowIndex = $wrapper.data("cursor-index");
                //const $cursorRow = $(dt.row(cursorRowIndex).node());

                //$cursorRow.removeClass("cursor");

                //let index = _.last(indexes);
                //if (index === cursorRowIndex && indexes.length > 1) {
                //    index = _.first(indexes);
                //}

                //const latestSelectedRow = dt.row(index).node();
                //$(latestSelectedRow).addClass("cursor");

                //$wrapper.data("cursor-index", index);
            }
        }
    });

    $(document).on("user-select.dt", function (e, dt, type, cell, originalEvent) {
        if (type === "row") {
            if (originalEvent.target && ($(originalEvent.target).closest("button").length > 0 || $(originalEvent.target).closest("a").length > 0)) {
                // if a <button> or <a> inside a row is being clicked, don't select/deselect the row.
                e.preventDefault();
                return;
            }

            const $wrapper = $(dt.table().container());
            const rowIndex = _.first(_.first(cell)).row;

            if (originalEvent.shiftKey) {
                const lastSelectedIndex = $wrapper.data("last-selected-index");

                let startIndex;
                let endIndex;
                if (rowIndex < lastSelectedIndex) {
                    startIndex = rowIndex;
                    endIndex = lastSelectedIndex;
                } else if (lastSelectedIndex < rowIndex) {
                    startIndex = lastSelectedIndex;
                    endIndex = rowIndex;
                } else {
                    startIndex = rowIndex;
                    endIndex = rowIndex;
                }

                const selectedRowIndexes = [];
                for (let i = startIndex; i <= endIndex; i++) {
                    selectedRowIndexes.push(i);
                }

                e.preventDefault();
                const selectedRows = dt.rows(selectedRowIndexes);
                if (originalEvent.ctrlKey) {
                    const lastSelectedState = $wrapper.data("last-selected-state");

                    if (lastSelectedState) {
                        selectedRows.select();
                    } else {
                        selectedRows.deselect();
                    }
                } else {
                    dt.rows().deselect();
                    selectedRows.select();
                }
            } else {
                $wrapper.data("last-selected-index", rowIndex);
                const $row = $(dt.row(rowIndex).node());
                // if it's selected, it will unselect, and vice versa (toggle)
                if ($row.hasClass("selected")) {
                    $wrapper.data("last-selected-state", false);
                } else {
                    $wrapper.data("last-selected-state", true);
                }
            }

            const cursorRowIndex = $wrapper.data("cursor-index");
            const $cursorRow = $(dt.row(cursorRowIndex).node());

            $cursorRow.removeClass("cursor");

            const latestSelectedRow = dt.row(rowIndex).node();
            $(latestSelectedRow).addClass("cursor");

            $wrapper.data("cursor-index", rowIndex);
        }
    });

    const scrollToMakeRowVisibleIfNeeded = function (api, row) {
        window.scrollIntoView(row, {
            scrollMode: "if-needed",
            block: "nearest",
            inline: "nearest"
        });

        const $wrapper = $(api.table().container());
        const $cursorRow = $(row);

        // page header and/or table header might be obscuring the row, modify the page scroll to bring the row into view.
        const $floatingHeader = $("table.fixedHeader-floating thead", $wrapper);

        let hasScrolled = false;

        if ($wrapper.closest(".modal").length > 0) {
            if ($floatingHeader.length > 0) {
                if ($wrapper.closest(".modal-dialog-scrollable").length > 0) {
                    const scrollableContainer = api.fixedHeader.scrollableContainer();
                    const $scrollableBody = scrollableContainer ? (scrollableContainer instanceof $ ? scrollableContainer : $(scrollableContainer)) : $wrapper.closest(".modal-body");

                    const modalBodyOffsetTop = $scrollableBody.offset().top;
                    if ($floatingHeader.height() > $cursorRow.offset().top - modalBodyOffsetTop) {
                        $scrollableBody.scrollTop($scrollableBody.scrollTop() - ($floatingHeader.height() - ($cursorRow.offset().top - modalBodyOffsetTop) + 1));
                        hasScrolled = true;
                    }
                } else {
                    if ($floatingHeader.height() > $cursorRow.offset().top) {
                        $wrapper.closest(".modal").scrollTop($wrapper.closest(".modal").scrollTop() - ($floatingHeader.height() - $cursorRow.offset().top + 1));
                        hasScrolled = true;
                    }
                }
            }
        } else {
            const tableTop = $($(".dataTable", $wrapper).get(0)).offset().top;
            const scrollTop = $(document).scrollTop();
            const headerOffset = app.utils.theme.getFixedHeaderOffset();
            let tableScrollTop = (scrollTop + headerOffset) - tableTop; // how far down the table is being scrolled. It's zero if the first row is just visible.

            let theadHeight = $('table:not(".fixedHeader-floating") thead', $wrapper).height();
            if (!theadHeight) {
                theadHeight = 0;
            } else {
                theadHeight += 1;
            }

            if ($floatingHeader.length === 0) {
                tableScrollTop -= theadHeight;
            }

            if (tableScrollTop > 0) {
                const rowRelativeTop = $cursorRow.position().top;
                const isRowHiddenFromTop = rowRelativeTop < tableScrollTop;

                if (isRowHiddenFromTop) {
                    let newScrollTop = $cursorRow.offset().top - headerOffset;

                    if ($floatingHeader.length > 0) {
                        newScrollTop -= theadHeight;
                    }

                    $(document).scrollTop(newScrollTop);
                    hasScrolled = true;
                }
            }
        }

        // page footer and/or table footer might be obscuring the row, modify the page scroll to bring the row into view.
        if (!hasScrolled) {
            const rowOffset = $cursorRow.offset().top;
            const rowHeight = $cursorRow.height();
            const $floatingFooter = $("table.fixedHeader-floating tfoot", $wrapper);

            let $scrollableBody;
            if ($wrapper.closest(".modal").length === 0) {
                $scrollableBody = $(document);
            } else if ($wrapper.closest(".modal-dialog-scrollable").length === 0) {
                $scrollableBody = $wrapper.closest(".modal");
            } else {
                const scrollableContainer = api.fixedHeader.scrollableContainer();
                $scrollableBody = scrollableContainer ? (scrollableContainer instanceof $ ? scrollableContainer : $(scrollableContainer)) : $wrapper.closest(".modal-body");
            }

            if ($floatingFooter.length > 0) {
                setTimeout(function () {
                    const floatingFooterOffset = $floatingFooter.offset().top;
                    if (rowOffset + rowHeight + 1 > floatingFooterOffset) {
                        const visibilityDifference = rowOffset + rowHeight + 1 - floatingFooterOffset;

                        $scrollableBody.scrollTop($scrollableBody.scrollTop() + visibilityDifference);
                    }
                });
            } else {
                let footerOffsetFromBottom = 0;
                if ($wrapper.closest(".modal").length === 0) {
                    footerOffsetFromBottom = app.utils.theme.getFixedHeaderOffset();
                }

                if (footerOffsetFromBottom > 0 && window.KTLayoutFooter) {
                    const $footer = $(window.KTLayoutFooter.getElement());
                    if ($footer.length > 0) {
                        const footerOffsetFromTop = $footer.offset().top;

                        if (rowOffset + rowHeight + 1 > footerOffsetFromTop) {
                            const visibilityDifference = rowOffset + rowHeight + 1 - footerOffsetFromTop;

                            $scrollableBody.scrollTop($scrollableBody.scrollTop() + visibilityDifference);
                        }
                    }
                }
            }
        }
    };
    const navigateDataTableWithModifierKeysPressed = function (dataTableApi, targetRowIndex, ctrlKey, altKey, shiftKey) {
        const $wrapper = $(dataTableApi.table().container());

        const newCursorRow = dataTableApi.row(targetRowIndex);
        const $newCursorRow = $(newCursorRow.node());

        if (ctrlKey && !shiftKey) {


        } else if (shiftKey) {
            const lastSelectedIndex = $wrapper.data("last-selected-index");

            let startIndex;
            let endIndex;
            if (lastSelectedIndex < targetRowIndex) {
                startIndex = lastSelectedIndex;
                endIndex = targetRowIndex;
            } else if (targetRowIndex < lastSelectedIndex) {
                startIndex = targetRowIndex;
                endIndex = lastSelectedIndex;
            } else {
                startIndex = lastSelectedIndex;
                endIndex = lastSelectedIndex;
            }

            const selectedRowIndexes = [];
            for (let i = startIndex; i <= endIndex; i++) {
                selectedRowIndexes.push(i);
            }

            const selectedRows = dataTableApi.rows(selectedRowIndexes);
            if (ctrlKey) {
                const lastSelectedState = $wrapper.data("last-selected-state");

                if (lastSelectedState) {
                    selectedRows.select();
                } else {
                    selectedRows.deselect();
                }
            } else {
                dataTableApi.rows().deselect();
                selectedRows.select();
            }
        } else {
            dataTableApi.rows().deselect();
            dataTableApi.row(targetRowIndex).select();
            $wrapper.data("last-selected-index", targetRowIndex);
        }

        const cursorRowIndex = $wrapper.data("cursor-index");
        const cursorRow = dataTableApi.row(cursorRowIndex);
        const $cursorRow = $(cursorRow.node());
        $cursorRow.removeClass("cursor");

        $newCursorRow.addClass("cursor");
        $wrapper.data("cursor-index", targetRowIndex);

        scrollToMakeRowVisibleIfNeeded(dataTableApi, newCursorRow.node());
    };
    const moveNext = app.throttle(50, function (e) {
        const api = $(this).DataTable();

        const $wrapper = $(api.table().container());

        const cursorRowIndex = $wrapper.data("cursor-index");
        const nextRowIndex = cursorRowIndex + 1;
        const rowCount = api.rows().count();

        if (nextRowIndex < rowCount) {
            navigateDataTableWithModifierKeysPressed(api, nextRowIndex, e.ctrlKey, e.altKey, e.shiftKey);
        }
    });
    const movePrevious = app.throttle(50, function (e) {
        const api = $(this).DataTable();

        const $wrapper = $(api.table().container());

        const cursorRowIndex = $wrapper.data("cursor-index");
        const previousRowIndex = cursorRowIndex - 1;

        if (previousRowIndex >= 0) {
            navigateDataTableWithModifierKeysPressed(api, previousRowIndex, e.ctrlKey, e.altKey, e.shiftKey);
        }
    });
    $(document).on("keydown", ".dataTable", function (e) {
        if (!$.fn.dataTable.isDataTable($(this))) {
            return;
        }

        if (e.target && $(e.target).is("input")) {
            return;
        }
        
        switch (e.key) {
            case app.consts.keyboardKey.space:
                {
                    e.preventDefault();
                    e.stopPropagation();

                    const api = $(this).DataTable();

                    const $wrapper = $(api.table().container());

                    const cursorRowIndex = $wrapper.data("cursor-index");
                    const cursorRow = api.row(cursorRowIndex);
                    const $cursorRow = $(cursorRow.node());

                    if ($cursorRow.hasClass("selected")) {
                        if (e.ctrlKey) {
                            cursorRow.deselect();
                            $wrapper.data("last-selected-index", cursorRowIndex);
                            $wrapper.data("last-selected-state", false);
                        }
                    } else {
                        cursorRow.select();
                        $wrapper.data("last-selected-index", cursorRowIndex);
                        $wrapper.data("last-selected-state", true);
                    }
                }
                break;

            case app.consts.keyboardKey.arrowDown:
                {
                    e.preventDefault();
                    e.stopPropagation();

                    moveNext.apply(this, arguments);
                }
                break;

            case app.consts.keyboardKey.arrowUp:
                {
                    e.preventDefault();
                    e.stopPropagation();

                    movePrevious.apply(this, arguments);
                }
                break;

            case "A":
            case "a":
                {
                    if (e.ctrlKey) {
                        e.preventDefault();
                        e.stopPropagation();

                        const api = $(this).DataTable();
                        api.rows().select();
                    }
                }
                break;

            case app.consts.keyboardKey.home:
                {
                    const api = $(this).DataTable();

                    const $wrapper = $(api.table().container());

                    if (e.ctrlKey && e.altKey && !e.shiftKey) {
                        // scroll to the top of the viewport.

                        e.preventDefault();
                        e.stopPropagation();

                        let scrollableBody;
                        if ($wrapper.closest(".modal").length === 0) {
                            scrollableBody = window;
                        } else if ($wrapper.closest(".modal-dialog-scrollable").length === 0) {
                            scrollableBody = $wrapper.closest(".modal").get(0);
                        } else {
                            const scrollableContainer = api.fixedHeader.scrollableContainer();
                            const $scrollableBody = scrollableContainer ? (scrollableContainer instanceof $ ? scrollableContainer : $(scrollableContainer)) : $wrapper.closest(".modal-body");
                            scrollableBody = $scrollableBody.get(0);
                        }

                        scrollableBody.scrollTo({ top: 0, behavior: "smooth" });
                    } else if (!e.altKey) {
                        e.preventDefault();
                        e.stopPropagation();

                        navigateDataTableWithModifierKeysPressed(api, 0, e.ctrlKey, e.altKey, e.shiftKey);
                    }
                }
                break;

            case app.consts.keyboardKey.end:
                {
                    const api = $(this).DataTable();

                    const $wrapper = $(api.table().container());
                    if (e.ctrlKey && e.altKey && !e.shiftKey) {
                        // scroll to the bottom of the viewport.

                        e.preventDefault();
                        e.stopPropagation();
                        let scrollableBody;
                        let scrollHeight;

                        if ($wrapper.closest(".modal").length === 0) {
                            scrollableBody = window;
                            scrollHeight = document.body.scrollHeight;
                        } else if ($wrapper.closest(".modal-dialog-scrollable").length === 0) {
                            scrollableBody = $wrapper.closest(".modal").get(0);
                            scrollHeight = scrollableBody.scrollHeight;
                        } else {
                            const scrollableContainer = api.fixedHeader.scrollableContainer();
                            const $scrollableBody = scrollableContainer ? (scrollableContainer instanceof $ ? scrollableContainer : $(scrollableContainer)) : $wrapper.closest(".modal-body");
                            scrollableBody = $scrollableBody.get(0);
                            scrollHeight = scrollableBody.scrollHeight;
                        }

                        scrollableBody.scrollTo({ top: scrollHeight, behavior: "smooth" });
                    } else if (!e.altKey) {
                        e.preventDefault();
                        e.stopPropagation();

                        navigateDataTableWithModifierKeysPressed(api, api.rows().count() - 1, e.ctrlKey, e.altKey, e.shiftKey);
                    }
                }
                break;
        }
    });
})(jQuery);
